import React from 'react';
import Section from "../../components/Section/Section";
import "./Politic.scss"

function Politic() {
	return (
		<Section>
			<div className="politic">
				<h3>Кто мы</h3>
				<p>Компания aidadeck-logistics<br></br>
					Наш адрес сайта: <a href="https://aidadeck-logistics.ru" target="_blank" rel="noreferrer">aidadeck-logistics.ru</a>
				</p>
				<h3>Политика конфиденциальности</h3>
				<p>Мы ценим вашу конфиденциальность и обязуемся защищать любую информацию, которую вы предоставляете нам. Эта политика конфиденциальности описывает, как мы собираем, используем и защищаем вашу информацию.</p>
				<h3>Сбор информации</h3>
				<p>Мы собираем информацию только в том случае, если вы добровольно предоставляете ее нам. Когда вы заполняете форму запроса на нашем сайте, мы просим вас указать свое имя и адрес электронной почты, а также задать вопрос. Мы используем эту информацию, чтобы ответить на ваш запрос и предоставить вам необходимую информацию.</p>
				<h3>Использование информации</h3>
				<p>Мы используем вашу информацию только для тех целей, для которых она была предоставлена нами. Мы не продаем, не арендуем и не обмениваем вашу информацию с третьими лицами. Мы также не используем вашу информацию для рассылки спама.</p>
				<h3>Защита информации</h3>
				<p>Мы используем различные меры безопасности, чтобы защитить вашу информацию от несанкционированного доступа, использования или раскрытия. Мы храним вашу информацию на защищенных серверах и используем шифрование для передачи конфиденциальной информации.</p>
				<h3>Доступ к информации</h3>
				<p>Вы можете запросить доступ к своей информации, которую мы храним, и запросить ее изменение или удаление. Чтобы запросить доступ к своей информации, свяжитесь с нами через контактную форму на нашем сайте.</p>
				<h3>Связь с нами</h3>
				<p>Если у вас есть какие-либо вопросы или замечания относительно нашей политики конфиденциальности, пожалуйста, свяжитесь с нами через контактную форму на нашем сайте. Мы рады помочь вам.</p>
			</div>
		</Section>
	);
}

export default Politic;